import { InMemoryCache, Cache, Operation, ApolloLink } from "@apollo/client";

export const apolloClientCache = new InMemoryCache({
  typePolicies: {
    ComplianceReports: {
      keyFields: [],
    },
    PayrollAnomalyReport: {
      merge: true,
    },
  }
});

export const outdatedCacheLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const outdatedObjects = outdatedCacheObjects(operation);
    if (outdatedObjects) {
      clearObjectsCache(outdatedObjects);
    }

    return response;
  });
});

const clearObjectsCache = (outdatedObjects: Cache.EvictOptions[]) => {
  outdatedObjects.forEach(outdatedObject => {
    apolloClientCache.evict(outdatedObject);
  });
  apolloClientCache.gc();
};

const outdatedCacheObjects = (operation: Operation): Cache.EvictOptions[] => {
  switch (operation.operationName) {
  case "createDisbursement":
    return [{ id: "ROOT_QUERY", fieldName: "disbursements" }];
  case "uploadBatchDisbursement":
    return [{ id: "ROOT_QUERY", fieldName: "batchDisbursements" }];
  default:
    return [];
  }
};
